export default __webpack_public_path__ + "static/media/home-travel-agency-blog-04.b7ea91b1.jpg";